let children = []

children.push({
    path: "/comercial/agenda-asesor",
    name: "COM_AGENDA_ASESOR",
    component: () =>
        import ("../views/Commercial/ComAgendaAsesor.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Comercial", disabled: true },
            { text: "Seguimiento de visitas", href: "/comercial/Seguimiento-visitas" },
        ],
    },
},
{
    path: "/comercial/seguimiento-asesor",
    name: "COM_SEGUIMIENTO_ASESOR",
    component: () =>
        import ("../views/Commercial/ComSeguimientoAsesor.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Comercial", disabled: true },
            { text: "Control de visitas", href: "/comercial/Control-visitas" },
        ],
    },
},
{
    path: "/comercial/promocion-publicidad",
    name: "COM_PROMOCION_PUBLICIDAD",
    component: () =>
        import ("../views/Commercial/ComOperacionesPromView.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Comercial", disabled: true },
            { text: "PROMOCION Y PUBLICIDAD", href: "/comercial/promocion-publicidad" },
        ],
    },
},
{
    path: "/comercial/formularios",
    name: "COM_DESIGN_FORMS",
    component: () =>
        import ("../views/Commercial/ComDesignForms.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Comercial", disabled: true },
            { text: "Formularios", href: "/comercial/formularios" },
        ],
    },
},
{
    path: "/comercial/activaciones",
    name: "COM_ACTIVACIONES",
    component: () =>
        import ("../views/Commercial/ComActivaciones.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Comercial", disabled: true },
            { text: "Activaciones", href: "/comercial/activaciones" },
        ],
    },
},
{
    path: "/comercial/activaciones/configurar",
    name: "COM_ACTIVACIONES_CONFIG",
    component: () =>
        import ("../views/Commercial/ComActivacionesConfig.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Comercial", disabled: true },
            { text: "Activaciones", disabled: true },
            { text: "Configurar", href: "/comercial/activaciones/configurar" },
        ],
    },
},
{
    path: "/comercial/activaciones/cargamasiva",
    name: "COM_ACTIVACIONES_MASIVE",
    component: () =>
        import ("../views/Commercial/ComActivacionesCargaMasiva.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Comercial", disabled: true },
            { text: "Activaciones", disabled: true },
            { text: "Carga Masiva", href: "/comercial/activaciones/cargamasiva" },
        ],
    },
},
{
    path: "/comercial/promotores",
    name: "COM_PROMOTORES",
    component: () =>
        import ("../views/Commercial/ComPromotores.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Comercial", disabled: true },
            { text: "Promotores", href: "/comercial/promotores" },
        ],
    },
},
);



export {
    children
}
